import { mitelRequest } from '../../../utils/mitelRequest';
import { OUTSIDE_API } from '../../../consts/endpoints';
import store from '../../../store/store';
import { actions as reduxActions } from '../reducers';

const getUser = async ({ userId, clientConnectId }) => {
  const { data: user } = await mitelRequest({
    options: {
      url: `${OUTSIDE_API.CLIENTS}/${clientConnectId}/users/${userId}`
    }
  });

  return store.dispatch(reduxActions.updateUser({ user }));
};

export default getUser;
